<script setup>
import { onMounted } from 'vue';

onMounted(() => {
    drawStars();
    window.addEventListener("resize", drawStars);
});

function drawStars() {
    let starsBoxShadow = '';
    let stars2BoxShadow = '';
    let stars3BoxShadow = '';
    const screenHeight = window.innerHeight;
    const screenWidth = window.innerWidth;
    const screenArea = (screenWidth * screenHeight);
    const smallStars = screenArea / 6000;
    const mediumStars = screenArea / 18000;
    const largeStars = screenArea / 72000;

    for (let i = 0; i < smallStars; i++) {
        starsBoxShadow += `${Math.floor(Math.random() * screenWidth)}px ${Math.floor(Math.random() * screenHeight)}px #FFF, `;

        if (i < mediumStars) {
            stars2BoxShadow += `${Math.floor(Math.random() * screenWidth)}px ${Math.floor(Math.random() * screenHeight)}px #FFF, `;
        }

        if (i < largeStars) {
            stars3BoxShadow += `${Math.floor(Math.random() * screenWidth)}px ${Math.floor(Math.random() * screenHeight)}px #FFF, `;
        }
    }

    starsBoxShadow = starsBoxShadow.slice(0, -2);
    stars2BoxShadow = stars2BoxShadow.slice(0, -2);
    stars3BoxShadow = stars3BoxShadow.slice(0, -2);

    document.getElementById('simple-star-background-stars')?.style.setProperty('--box-shadow', starsBoxShadow);
    document.getElementById('simple-star-background-stars2')?.style.setProperty('--box-shadow', stars2BoxShadow);
    document.getElementById('simple-star-background-stars3')?.style.setProperty('--box-shadow', stars3BoxShadow);
}
</script>
<style>
#simple-star-background-stars {
    width: 1px;
    height: 1px;
    background: transparent;
    box-shadow: var(--box-shadow);
    animation: animStar 50s linear infinite;
}

#simple-star-background-stars:after {
    content: " ";
    position: absolute;
    top: 100vh;
    width: 1px;
    height: 1px;
    background: transparent;
    box-shadow: var(--box-shadow);
}

#simple-star-background-stars2 {
    width: 2px;
    height: 2px;
    background: transparent;
    box-shadow: var(--box-shadow);
    animation: animStar 100s linear infinite;
}

#simple-star-background-stars2:after {
    content: " ";
    position: absolute;
    top: 100vh;
    width: 2px;
    height: 2px;
    background: transparent;
    box-shadow: var(--box-shadow);
}

#simple-star-background-stars3 {
    width: 3px;
    height: 3px;
    background: transparent;
    box-shadow: var(--box-shadow);
    animation: animStar 150s linear infinite;
}

#simple-star-background-stars3:after {
    content: " ";
    position: absolute;
    top: 100vh;
    width: 3px;
    height: 3px;
    background: transparent;
    box-shadow: var(--box-shadow);
}

@keyframes animStar {
    from {
        transform: translateY(0px);
    }

    to {
        transform: translateY(-100vh);
    }
}
</style>
<template>
    <div class="absolute inset-0 overflow-hidden -z-50"
        style="background: radial-gradient(ellipse at bottom, #140F2D 0%, #090A0F 100%)">
        <div id='simple-star-background-stars'></div>
        <div id='simple-star-background-stars2'></div>
        <div id='simple-star-background-stars3'></div>
    </div>
</template>